export default __webpack_public_path__ + "static/media/eduOrange.c61dcfc3.svg";